<template>
  <div class="order-page">
    <el-card class="box-card">
      <el-form :model="form"
               label-width="85px"
               :rules="rfmrules"
               ref="rfmForm"
               style="width: 100%">
        <el-row>
          <el-col :span="6">
            <el-form-item prop="type"
                          label="报表">
              <el-select clearable
                         v-model="form.type"
                         placeholder="请选择报表类型"
                         @change="changeType"
                         style="width: 100%">
                <el-option v-for="item in type_list"
                           :key="item.value"
                           :label="item.name"
                           :value="item.value">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>

      </el-form>
    </el-card>

    <el-card class="button-box"
             v-loading="loading"
             v-if="showContent || showNone">

      <el-row type="flex"
              justify="center"
              v-if="showNone"
              class="
              edit">
        <el-col>
          <el-alert title='该报表暂未设置说明,直接编辑提交说明...'
                    type="warning"
                    center
                    show-icon
                    :closable="false">
          </el-alert>
        </el-col>
      </el-row>
      <el-row type="flex"
              justify="center"
              v-if="showContent"
              class="
              edit">
        <el-col>
          <el-alert :title='`${content.created_user} 创建于 ${content.created_at}`'
                    type="info"
                    center
                    show-icon
                    :closable="false">
          </el-alert>
        </el-col>
      </el-row>
      <el-row type="flex"
              justify="center"
              class="
              edit">
        <el-col :span="24">

          <quill-editor ref="text"
                        v-model="content.desc"
                        class="myQuillEditor"
                        :options="editorOption" />

        </el-col>

      </el-row>

    </el-card>
    <el-card class="
                     button-box"
             v-if="showIcon">

      <el-row type="flex"
              justify="center">
        <el-col :sm="12"
                :lg="6">

          <div class="el-result">
            <div class="el-result__icon">
              <svg viewBox="0 0 48 48"
                   xmlns="http://www.w3.org/2000/svg"
                   class="icon-info">
                <path
                      d="M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M24,19 L21,19 C20.1715729,19 19.5,19.6715729 19.5,20.5 C19.5,21.3284271 20.1715729,22 21,22 L21,22 L22.5,22 L22.5,31 L21,31 C20.1715729,31 19.5,31.6715729 19.5,32.5 C19.5,33.3284271 20.1715729,34 21,34 L21,34 L27,34 C27.8284271,34 28.5,33.3284271 28.5,32.5 C28.5,31.6715729 27.8284271,31 27,31 L27,31 L25.5,31 L25.5,20.5 C25.5,19.6715729 24.8284271,19 24,19 L24,19 Z M24,13 C22.8954305,13 22,13.8954305 22,15 C22,16.1045695 22.8954305,17 24,17 C25.1045695,17 26,16.1045695 26,15 C26,13.8954305 25.1045695,13 24,13 Z">
                </path>
              </svg>
            </div>
            <div class="el-result__subtitle">
              <p style=" opacity: 0.6;">请先选择需要添加或修改说明的报表</p>
            </div>
          </div>
          <!-- <el-result icon="info"
                     subTitle="无配置，请新增配置"> -->
          <!-- <template slot="extra"> -->
          <!-- <el-button type="primary"
                         :loading="loading"
                         icon="el-icon-circle-plus-outline"
                         @click="handleAdd">新增配置</el-button> -->
          <!-- <el-button type="primary"
                         size="medium">返回</el-button> -->
          <!-- </template> -->
          <!-- </el-result> -->
        </el-col>

      </el-row>

    </el-card>
    <el-card class="button-box"
             v-if="showContent || showNone">

      <el-row>
        <el-col>
          <el-button type="primary"
                     :loading="loading"
                     @click="submit">提交</el-button>
          <!-- <el-button type="primary"
                     :loading="loading"
                     @click="handleClick">导出</el-button> -->
          <el-button @click="resetForm">清空内容</el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {
  getplatlists,
  getptnlists,
  getshoplists,
  gettradestatus,
  gettradefrom,
} from '@/common/mixins/select'
import { parseTime } from '@/utils/index'

import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
const tempPrefixeUrl = 'http://test.databankapi.transecs.com/'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
  mixins: [getplatlists, getptnlists, getshoplists, gettradefrom, SearchMixin],
  components: {
    quillEditor,
  },
  data() {
    return {
      form: {
        type: '',
        profession: '',
        store: '',
        business: '',
        time: '',
        remark: '',
        timeA: [],
        timeB: [],
        interval: '',
        prdType: '',
        category1: '',
        category2: '',
        skuCode: '',
      },
      content: {
        desc: '',
        created_at: '',
        created_user: '',
        updated_at: '',
        updated_user: '',
      },
      // content: '',
      editorOption: {},
      dialogData: this.form,
      loading: false,
      tableData: [],
      msg: '',
      Desc,
      showContent: false,
      showNone: false,
      showSelect: false,
      showIcon: true,
      reportTypeList: [],
      'label-width': '90px',
      type_list: [
        { name: '销售额单月', value: 1 },
        { name: '顾客继续新规', value: 2 },
        { name: '顾客Recency&运转率', value: 3 },
        { name: '顾客F×M累计', value: 4 },
        { name: '顾客level报表', value: 5 },
        { name: '顾客继续-既存', value: 6 },
        { name: '顾客继续-整体', value: 7 },
        { name: '销售额移动和', value: 8 },
        { name: '顾客存活', value: 9 },
        { name: '顾客FM累计-12个月', value: 10 },
        { name: '商品-新客', value: 11 },
        { name: '商品-交叉营销', value: 12 },
        { name: '商品-继续', value: 13 },
      ],
      rfmrules: {
        type: [{ required: true, message: '请选择报表类型', trigger: 'blur' }],
        profession: [
          { required: true, message: '请选择行业', trigger: 'blur' },
        ],
        business: [{ required: true, message: '请选择商家', trigger: 'blur' }],
        store: [{ required: true, message: '请选择店铺', trigger: 'blur' }],
      },
    }
  },
  created() {
    // this.getTableData();
    // this.getOperatelogReporttype()
  },
  methods: {
    // 文本编辑器
    async submit() {
      if (!this.form.type) {
        this.$message.error('请选择报表类型')
        return
      }
      if (!this.content.desc) {
        this.$message.error('报表说明不可为空')
        return
      }
      var formData = {
        type: this.form.type,
        desc: this.content.desc,
      }
      this.loading = true
      let { data, err } = await this.axiosApi(Desc.create_export_desc, formData)
      console.log('data', data.data.data)
      this.loading = false
      if (data && data.data.meta.status == 200) {
        this.$message({
          message: data.data.data,
          type: 'success',
          showClose: true,
          duration: 1000,
        })
        // this.$message.success(data.data.data.message)
      }
      dealReturn(data, err)
    },
    // submit() {
    //   console.log(this.$refs.text.value)
    // },
    changeType() {
      // this.content = ''
      this.showIcon = false
      this.getExportDesc()
    },
    async getExportDesc() {
      this.loading = true
      this.showContent = false
      this.showNone = false
      this.content = {
        desc: '',
        created_at: '',
        created_user: '',
        updated_at: '',
        updated_user: '',
      }
      // console.log(this.form.business)
      // console.log(this.form.store)
      if (!this.form.type) {
        this.$message.error('请选择报表')
        return
      }

      let { data, err } = await this.axiosApi(Desc.get_export_desc, {
        type: this.form.type,
      })
      // console.log('data', data.data.data)
      // console.log('error', err)

      // console.log(JSON.parse(data.data.data[0]))
      if (data && data.data && data.data.data) {
        // console.log("data", data)
        this.content.desc = data.data.data.desc
        this.content.created_at = parseTime(data.data.data.created_at)
        this.content.created_user = data.data.data.created_user
        this.content.updated_at = data.data.data.updated_at
        this.content.deupdated_usersc = data.data.data.updated_user
        this.showContent = true
        this.showNone = false
      } else {
        this.showContent = false
        this.showNone = true
      }
      // dealReturn(data, err)
      this.loading = false
    },
    resetForm() {
      // this.form = {
      //   type: '',
      // }
      this.content.desc = ''
    },
    handleClick() {
      let isValid
      this.$refs.rfmForm.validate((valid) => {
        isValid = valid
      })
      console.log('isValid', isValid)
      if (!isValid) {
        return
      }

      if (this.form.type == 12) {
        if (!this.form.timeA) {
          this.$message.error('请选择时间段A')
          return
        }
        if (!this.form.timeB) {
          this.$message.error('请选择时间段B')
          return
        }
      }
      if (this.form.type == 5) {
        if (!this.form.interval) {
          this.$message.error('请选择范围')
          return
        }
      }
      if (!this.form.type) {
        this.$message.error('请选择报表类型')
        return
      }

      if (!this.form.store) {
        this.$message.error('请先选择店铺')
        return
      }
      if (this.form.type != 12) {
        if (!this.form.time) {
          this.$message.error('请选择时间')
          return
        }
      }

      var formData = {
        type: this.form.type,
        profession: this.form.profession,
        store: this.form.store,
        business: this.form.business,
        remark: this.form.remark,
      }

      if (this.form.type == 12) {
        ;(formData.timeA = this.form.timeA), (formData.timeB = this.form.timeB)
      } else {
        formData.time = this.form.time
      }

      if (this.form.type == 5) {
        formData.interval = this.form.interval
      }

      if (this.form.type == 13) {
        formData.skuCode = this.form.skuCode
        formData.category1 = this.form.category1
        formData.category2 = this.form.category2
        formData.prdType = this.form.prdType
      }
      this.rfmReport(formData)
    },

    async rfmReport(formData) {
      this.loading = true
      let { data, err } = await this.axiosApi(Desc.rfm_api, formData)
      console.log('data', data)
      this.loading = false
      if (data && data.data.meta.status == 200) {
        this.$alert('导出成功，请稍后在导出日志查看', '导出成功', {
          confirmButtonText: '确定',
          type: 'success',
        })
      }
      dealReturn(data, err)
    },
  },
}
</script>
<style lang="scss">
.ql-editor{
  height: 400px;

}
.ql-container{
  height: 400px;
}

</style>

<style lang="scss" scoped>
.ql-editor{
  height: 400px;

}
.ql-container{
  height: 400px;
}

.title {
  display:inline;
  padding-left: 50px;
  font-size: 12px;
  color: #909399;
  height: 100px;
}
.row-bg{
// padding: 20px 20px;
// margin: 20px;
// background-color: red;
margin-bottom: 10px;
}
.table-title{
  color: #606266
;
  font-weight: 800;
  // padding-bottom: 10px;
  margin-top: 10px;
  // background-color: red;
}
.col-border{
  border: 1px solid #EBEEF5;
}
.col-right{
  text-align: right;
  width: 100%;


}
.icon-info {
    fill: #909399;
}
.el-result__icon svg {
    width: 64px;
    height: 64px;
}
svg:not(:root) {
    overflow: hidden;
}
.el-result {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    text-align: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px 30px;
    //     font-size: 14px;
    // color: #797a7b;
    font-size: 17px; font-weight: 800; opacity: 0.7;
    // font-weight: 600;

}
.el-result__subtitle {
    margin-top: 10px;
}
.el-result__subtitle p {
    margin: 0;
    font-size: 14px;
    color: #606266;
    line-height: 1.3;}

text{
  text-align: left;
}
.edit{
  margin: 10px;
}
   
</style>>


// WEBPACK FOOTER //
// src/views/rfm/createExportDesc/index.vue